<template>
  <div>
    <div class="fixed-nav">
      <div class="app-container">
        <div class="nav-wrapper">
          <div
            data-animation="default"
            data-collapse="medium"
            data-duration="400"
            data-easing="ease"
            data-easing2="ease"
            role="banner"
            class="navbar w-nav"
          >
            <div class="nav-container">
              <div class="div-block-3">
                <router-link
                  to="/professional-dashboard"
                  class="brand w-nav-brand"
                  ><img
                    src="@/assets/timeslot-images/timeslate-logo.svg"
                    loading="lazy"
                    class="image-25"
                    alt=""
                /></router-link>
                <!--                <form action="/search" class="search w-form">-->
                <!--                  <input-->
                <!--                    type="search"-->
                <!--                    class="search-input w-input"-->
                <!--                    maxlength="256"-->
                <!--                    name="query"-->
                <!--                    placeholder="Search e.g Product designer"-->
                <!--                    id="search"-->
                <!--                    required=""-->
                <!--                  /><input-->
                <!--                    type="submit"-->
                <!--                    value="Search"-->
                <!--                    class="search-button w-button"-->
                <!--                  />-->
                <!--                </form>-->
              </div>

              <div>
                <div class="w-nav-button">
                  <div class="w-icon-nav-menu"></div>
                </div>
                <nav role="navigation" class="nav-menu w-nav-menu">
                  <router-link
                    to="/discover"
                    aria-current="page"
                    :class="
                      isActive('/discover')
                        ? 'app-navlink w-nav-link w--current'
                        : 'app-navlink w-nav-link'
                    "
                    >Discover</router-link
                  >

                  <!--                  <router-link-->
                  <!--                    v-if="userInfo.userRole === 'Customer'"-->
                  <!--                    to="/become-a-professional"-->
                  <!--                    aria-current="page"-->
                  <!--                    :class="-->
                  <!--                      isActive('/become-a-professional')-->
                  <!--                        ? 'app-navlink w-nav-link w&#45;&#45;current'-->
                  <!--                        : 'app-navlink w-nav-link'-->
                  <!--                    "-->
                  <!--                    >Become a professional</router-link-->
                  <!--                  >-->

                  <!--                <router-link to="/become-a-professional" :class="isActive('/become-a-professional') ? 'app-navlink w-nav-link w&#45;&#45;current' : 'app-navlink w-nav-link'">Become a professional</router-link>-->
                  <div
                    data-hover="false"
                    data-delay="0"
                    class="w-dropdown"
                    v-click-outside="onClickOutsideNotification"
                  >
                    <div
                      class="dropdown-toggle-mine w-dropdown-toggle"
                      @click="toggleNotificationNav"
                    >
                      <img
                        src="@/assets/timeslot-images/notification1.svg"
                        loading="lazy"
                        alt=""
                      />
                    </div>
                    <nav
                      class="notification w-dropdown-list"
                      v-if="notification"
                    >
                      <div class="notification-header">
                        <div class="text-block-76" @click="goToNotifications">
                          View all notifications
                        </div>
                        <!--                        <div class="text-block-77">Mark all as read</div>-->
                      </div>
                      <div
                        class="notification-content"
                        v-if="unreadNotifications.length !== 0"
                      >
                        <div></div>

                        <div
                          class="content-1"
                          v-for="(notification,
                          index) in unreadNotifications.slice(0, 5)"
                          :key="index"
                          @click="view(notification)"
                        >
                          <img
                            :src="
                              notification.customerDisplayPicture ||
                                require('@/assets/timeslot-images/profileImg.svg')
                            "
                            loading="lazy"
                            width="41"
                            alt=""
                            class="image-22"
                          />
                          <div
                            class="text-block-78"
                            v-if="
                              notification.notificationModule.toLowerCase() ===
                                'message request' &&
                                notification.notificationAction.toLowerCase() ===
                                  'create'
                            "
                          >
                            Message request sent by
                            <a href="#" class="link-17">{{
                              notification.customerName
                            }}</a>
                          </div>
                          <div
                            class="text-block-78"
                            v-if="
                              notification.notificationModule.toLowerCase() ===
                                'subscription' &&
                                notification.notificationAction.toLowerCase() ===
                                  'create'
                            "
                          >
                            Subscription requested by
                            <a href="#" class="link-17">{{
                              notification.customerName
                            }}</a>
                          </div>
                          <div
                            class="text-block-78"
                            v-if="
                              notification.notificationModule.toLowerCase() ===
                                'booking' &&
                                notification.notificationAction.toLowerCase() ===
                                  'cancel'
                            "
                          >
                            Booking cancelled by
                            <a href="#" class="link-17">{{
                              notification.customerName
                            }}</a>
                          </div>
                          <div
                            class="text-block-78"
                            v-if="
                              notification.notificationModule.toLowerCase() ===
                                'subscription' &&
                                notification.notificationAction.toLowerCase() ===
                                  'success'
                            "
                          >
                            Subscription by
                            <a href="#" class="link-17">{{
                              notification.customerName
                            }}</a>
                            approved
                          </div>
                          <div
                            class="text-block-78"
                            v-if="
                              notification.notificationModule.toLowerCase() ===
                                'message' &&
                                notification.notificationAction.toLowerCase() ===
                                  'create'
                            "
                          >
                            Message sent by
                            <a href="#" class="link-17">{{
                              notification.customerName
                            }}</a>
                          </div>
                          <div
                            class="text-block-78"
                            v-if="
                              notification.notificationModule.toLowerCase() ===
                                'booking' &&
                                notification.notificationAction.toLowerCase() ===
                                  'create'
                            "
                          >
                            Booking made by
                            <a href="#" class="link-17">{{
                              notification.customerName
                            }}</a>
                          </div>
                        </div>
                      </div>
                      <div class="notification-content" v-else>
                        <div
                          class="empty-message-container margin-notification "
                        >
                          <img
                            src="@/assets/timeslot-images/notification1.svg"
                            width="42"
                            height="42"
                          />
                          <div class="new-message ">Nothing to show here</div>
                          <div class="new-message-sub">
                            Notifications from your interactions<br />
                            with clients would show up here
                          </div>
                          <!--                          <router-link-->
                          <!--                              to="/discover-professionals"-->
                          <!--                              class="timeslot-button w-button"-->
                          <!--                          >Discover professionals</router-link-->
                          <!--                          >-->
                        </div>
                      </div>
                    </nav>
                  </div>
                  <div
                    class="notification-badge"
                    v-if="unreadNotifications.length !== 0"
                  >
                    {{ unreadNotifications.length }}
                  </div>
                  <div
                    data-hover="false"
                    data-delay="0"
                    class="dropdown w-dropdown"
                    v-click-outside="onClickOutside"
                  >
                    <div
                      class="dropdown-toggle-2 w-dropdown-toggle"
                      @click="toggleNav"
                    >
                      <img
                        v-if="'customerDisplayPicture' in customerInfo"
                        class="image-profile-pic"
                        :src="customerInfo.customerDisplayPicture"
                      />
                      <div class="text-block-5" v-else>
                        {{ userInfo.customerFirstName.charAt(0)
                        }}{{ userInfo.customerLastName.charAt(0) }}
                      </div>
                    </div>
                    <nav class="dropdown-list w-dropdown-list" v-if="nav">
                      <div class="div-block-4 top">
                        <div class="div-block-5">
                          <div class="div-block-6">
                            <img
                              v-if="'customerDisplayPicture' in customerInfo"
                              class="image-profile-pic"
                              :src="customerInfo.customerDisplayPicture"
                            />
                            <div v-else class="text-block-8">
                              {{ userInfo.customerFirstName.charAt(0)
                              }}{{ userInfo.customerLastName.charAt(0) }}
                            </div>
                          </div>
                          <div>
                            <div class="text-block-6">
                              {{ userInfo.customerFirstName }}
                              {{ userInfo.customerLastName }}
                            </div>
                            <div class="text-block-7" @click="goToProfile">
                              View profile
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="div-block-4 middle">
                        <router-link
                          to="/professional-bookings"
                          class="dropdown-link bookings w-dropdown-link"
                          >My Bookings</router-link
                        >
                        <a
                          href="#"
                          class="dropdown-link share-profile w-dropdown-link"
                          @click="openProfile"
                          >Share Profile</a
                        >
                        <!--                                                <router-link-->
                        <!--                                                  v-if="userInfo.userRole === 'Customer'"-->
                        <!--                                                  to="/become-a-professional"-->
                        <!--                                                  class="dropdown-link prof w-dropdown-link"-->
                        <!--                                                  >Become a professional</router-link-->
                        <!--                                                >-->
                      </div>
                      <div class="div-block-4 bottom">
                        <router-link
                          to="/professional-settings"
                          class="dropdown-link settings w-dropdown-link"
                          >Settings</router-link
                        >
                        <router-link
                          to="/professional-support"
                          class="dropdown-link support w-dropdown-link"
                          >Support</router-link
                        >
                        <div
                          class="dropdown-link logout w-dropdown-link"
                          @click="logout"
                        >
                          Log out
                        </div>
                      </div>
                    </nav>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ShareProfileModal v-if="profile" :cancel="closeProfile" />
    </div>
    <!--    <div data-collapse="medium" data-animation="over-left" data-duration="400" data-w-id="df38f32a-3fbb-f2fb-24e9-fdc828eab25c" data-easing="ease" data-easing2="ease" role="banner" class="navbar-mobile w-nav">-->
    <!--      <div class="navbar1_container">-->
    <!--        <a href="#" class="navbar1_logo-link w-nav-brand">-->
    <!--          <img src="../../assets/timeslot-images/bookaslot-logo.svg" loading="lazy" alt="" class="navbar1_logo">-->
    <!--        </a>-->
    <!--        <div class="navbar1_menu-button w-nav-button" @click="showMobileMenu"  style="-webkit-user-select: text;" aria-label="menu" role="button" tabindex="0" aria-controls="w-nav-overlay-0" aria-haspopup="menu" aria-expanded="false">-->
    <!--          <div class="menu-icon1">-->
    <!--            <div class="menu-icon1_line-top" style="transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"></div>-->
    <!--            <div class="menu-icon1_line-middle" style="width: 24px; height: 2px;">-->
    <!--              <div class="menu-icon_line-middle-inner"></div>-->
    <!--            </div>-->
    <!--            <div class="menu-icon1_line-bottom" style="transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"></div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <div :class="cross ?  'w-nav  w-nav-overlay' : 'w-nav-overlay'"  data-wf-ignore="" id="w-nav-overlay-0"  v-if="cross">-->
    <!--        <nav role="navigation" @click="showHamburger" class="navbar1_menu w-nav-menu" data-nav-menu-open="" style="transform: translateX(0px) translateY(0px);">-->
    <!--          <div class="div-block-4-copy top">-->
    <!--            <a data-w-id="df38f32a-3fbb-f2fb-24e9-fdc828eab262" href="#" class="link-block-3 w-inline-block"><img src="../../assets/timeslot-images/cancel.svg" loading="lazy" alt="">-->
    <!--            </a>-->
    <!--            <div class="div-block-51">-->
    <!--              <div class="div-block-5-copy">-->
    <!--                <div class="div-block-6-copy">-->
    <!--                  <div class="text-block-8">SO</div>-->
    <!--                </div>-->
    <!--                <div class="div-block-28">-->
    <!--                  <div class="text-block-6">Seun Orofin</div>-->
    <!--                  <div class="text-block-7">-->
    <!--                    <router-link to="/professional-profile" class="link-18">View profile</router-link>-->
    <!--                  </div>-->
    <!--                </div>-->
    <!--              </div>-->
    <!--              <div class="div-block-29">-->
    <!--                <router-link to="/professional-dashboard" aria-current="page" class="link-block-4 dashboard w-inline-block w&#45;&#45;current">-->
    <!--                  <div class="text-block-27">Dashboard</div>-->
    <!--                </router-link>-->
    <!--                <router-link to="/professional-messages" class="link-block-4 message w-inline-block">-->
    <!--                  <div class="text-block-27">Messages</div>-->
    <!--                </router-link>-->
    <!--                <router-link to="/professional-bookings" class="link-block-4 booking w-inline-block">-->
    <!--                  <div class="text-block-27">Bookings</div>-->
    <!--                </router-link>-->
    <!--                <router-link to="/professional-feeds" class="link-block-4 feeds w-inline-block">-->
    <!--                  <div class="text-block-27">Feeds</div>-->
    <!--                </router-link>-->
    <!--                <router-link to="/professional-wallets" class="link-block-4 wallet w-inline-block">-->
    <!--                  <div class="text-block-27">Wallet</div>-->
    <!--                </router-link>-->
    <!--                <router-link to="/professional-settings" class="link-block-4 settings w-inline-block">-->
    <!--                  <div class="text-block-27">Settings</div>-->
    <!--                </router-link>-->
    <!--              </div>-->
    <!--              <div class="div-block-29-copy">-->
    <!--                <a href="#" class="link-block-4 support w-inline-block">-->
    <!--                  <div class="text-block-27">Support</div>-->
    <!--                </a>-->
    <!--                <a href="#" class="link-block-4 log-out w-inline-block">-->
    <!--                  <div class="text-block-27">Log out</div>-->
    <!--                </a>-->
    <!--              </div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--          <div></div>-->
    <!--        </nav>-->
    <!--      </div>-->
    <!--  </div>-->
  </div>
</template>

<script>
import vClickOutside from "v-click-outside";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import { mapState } from "vuex";
import CustomerRequest from "@/model/requests/CustomerRequest";
import RouterUtils from "@/utils/BaseUtils/RouterUtils";
import NotificationRequest from "@/model/requests/NotificationRequest";
import ShareProfileModal from "@/components/modal/ShareProfileModal";

export default {
  name: "ProfessionalAppNavBar",
  components: { ShareProfileModal },
  data() {
    return {
      notification: false,
      nav: false,
      readCustomerModel: CustomerRequest.readBy,
      notifyModel: NotificationRequest.readNotifications,
      profile: false
    };
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  computed: {
    ...mapState({
      userInfo: state => state.auth.userInfo,
      singleProfessional: state => state.professional.singleProfessional,
      professionalInfo: state => state.professional.professionalInfo,
      customerInfo: state => state.customer.customerInfo,
      notifications: state => state.notificationMessage.notifications,
      professionalId: state => state.professional.professionalId
    }),
    nameList() {
      let names = this.customerInfo.customerName.split(" ");
      return names;
    },
    firstLetter() {
      return this.nameList[0].charAt(0);
    },
    secondLetter() {
      return this.nameList[1].charAt(0);
    },
    unreadNotifications() {
      return this.notifications.filter(
        item => item.notificationStatus.toLowerCase() === "unread"
      );
    }
  },
  methods: {
    isActive(route) {
      return this.$route.path === route || this.$route.path.startsWith(route);
    },
    toggleNotificationNav() {
      this.notification = !this.notification;
      this.nav = false;
    },
    toggleNav() {
      this.nav = !this.nav;
      this.notification = false;
    },
    logout() {
      StoreUtils.dispatch(StoreUtils.actions.auth.LOGOUT);
    },
    routing() {
      return RouterUtils.changeRouteTo(
        RouterUtils.routes.auth.PROFESSIONAL_DASHBOARD
      );
    },
    goToProfile() {
      let professionalId;
      if ("professional" in this.userInfo) {
        professionalId = this.userInfo.professional.professionalId;
      } else {
        professionalId = this.customerToProfessionalId;
      }
      RouterUtils.changeRouteUrlTo(`/professionals/${professionalId}`);
    },
    view(notification) {
      let notify = { notificationId: notification.notificationId };
      // this.updateModel.notificationId = "106";
      // this.updateModel.notificationId = notification.notificationId;
      // this.updateModel.notificationRecipient =
      //     notification.notificationRecipient;
      StoreUtils.dispatch("notificationMessage/updateStatus", notify).then(
        () => {
          let notify = { notificationRecipient: this.userInfo.customerId };
          StoreUtils.dispatch("notificationMessage/readNotifications", notify);
        }
      );

      if (notification.notificationModule.includes("Message")) {
        RouterUtils.changeRouteTo(
          RouterUtils.routes.auth.PROFESSIONAL_MESSAGES
        );
      }
      if (notification.notificationModule.includes("Subscription")) {
        RouterUtils.changeRouteTo(
          RouterUtils.routes.auth.PROFESSIONAL_SUBSCRIPTIONS
        );
      }
      if (notification.notificationModule.includes("Booking")) {
        RouterUtils.changeRouteTo(
          RouterUtils.routes.auth.PROFESSIONAL_BOOKINGS
        );
      }
    },
    goToNotifications() {
      RouterUtils.changeRouteUrlTo("/professional-notifications");
    },
    openProfile() {
      this.profile = true;
    },
    closeProfile() {
      this.profile = false;
    },
    onClickOutside() {
      if (this.nav) {
        this.nav = false;
      }
    },
    onClickOutsideNotification() {
      if (this.notification) {
        this.notification = false;
      }
    }
  },
  mounted() {
    // this.readProfModel.professionalId = this.professionalId;
    // StoreUtils.dispatch(
    //   StoreUtils.actions.professional.READ_BY_PROFESSIONAL,
    //   this.readProfModel
    // );
    // this.readCustomerModel.customerId = this.userInfo.customerId;
    // StoreUtils.dispatch(
    //   StoreUtils.actions.customer.READ_BY_CUSTOMER,
    //   this.readCustomerModel
    // );
  }
};
</script>

<style scoped>
/*.overlay-open{*/
/*  height: 844px;*/
/*  width: 390px;*/
/*  top: 0;*/
/*  z-index: 1;*/
/*  right: auto;*/
/*}*/

.notification-badge {
  width: 20px;
  height: 20px;
  background-color: #256ff6;
  color: white;
  border-radius: 50%;
  text-align: center;
  font-family: GTEestiProDisplay-Medium, sans-serif;
  position: relative;
  top: -10px;
  right: 13px;
  font-size: 14px;
}
</style>
